<template>
  <!-- 运维档案 -->
  <div class="container">
    <div class="site-info" style="display: flex;flex-wrap: wrap;" v-if="operationData !=null">
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-bianma" style="margin-right: 10px;"></div>控制级别</div>
        <div class="site-info-content" :class="operationData.controlLevel_dictText?'':'none'">{{operationData.controlLevel_dictText ? operationData.controlLevel_dictText : '暂无数据'}}</div>
      </div>
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-huanbao1" style="margin-right: 10px;"></div>水体类型</div>
        <div class="site-info-content" :class="operationData.riverType_dictText?'':'none'">{{operationData.riverType_dictText ? operationData.riverType_dictText : '暂无数据'}}</div>
      </div>
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-icon--1" style="margin-right: 10px;font-size: 25px;padding-top: 1px;"></div>断面名称</div>
        <div class="site-info-content" :class="operationData.sectionName?'':'none'">{{operationData.sectionName ? operationData.sectionName : '暂无数据'}}</div>
      </div>
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-area" style="margin-right: 10px;"></div>点位编码</div>
        <div class="site-info-content" :class="operationData.pointCoding?'':'none'">{{operationData.pointCoding ? operationData.pointCoding : '暂无数据'}}</div>
      </div>
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-jieshao" style="margin-right: 10px;"></div>运维单位</div>
        <div class="site-info-content" :class="operationData.devopsUnit?'':'none'">{{operationData.devopsUnit ? operationData.devopsUnit : '暂无数据'}}</div>
      </div>
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-jieshao" style="margin-right: 10px;"></div>站房面积</div>
        <div class="site-info-content" :class="operationData.houseArea?'':'none'">{{operationData.houseArea ? operationData.houseArea : '暂无数据'}}</div>
      </div>
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-jieshao" style="margin-right: 10px;"></div>站房类型</div>
        <div class="site-info-content" :class="operationData.houseType_dictText?'':'none'">{{operationData.houseType_dictText ? operationData.houseType_dictText : '暂无数据'}}</div>
      </div>
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-jieshao" style="margin-right: 10px;"></div>采水方式</div>
        <div class="site-info-content" :class="operationData.waterCollection_dictText?'':'none'">{{operationData.waterCollection_dictText ? operationData.waterCollection_dictText : '暂无数据'}}</div>
      </div>
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-jieshao" style="margin-right: 10px;"></div>通信方式</div>
        <div class="site-info-content" :class="operationData.communication_dictText?'':'none'">{{operationData.communication_dictText ? operationData.communication_dictText : '暂无数据'}}</div>
      </div>
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-jieshao" style="margin-right: 10px;"></div>投运时间</div>
        <div class="site-info-content" :class="operationData.operationTime?'':'none'">{{operationData.operationTime ? operationData.operationTime : '暂无数据'}}</div>
      </div>
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-jieshao" style="margin-right: 10px;"></div>上下游污染情况</div>
        <div style="width: 100%;height: 120px;color: #0ff;font-size: 16px;overflow: scroll;color: #0ff;text-indent:2rem;" :class="operationData.pollutionSituation?'':'none'">{{operationData.pollutionSituation ? operationData.pollutionSituation : '暂无数据'}}</div>
      </div>
      <div class="site-info-border">
        <div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-jieshao" style="margin-right: 10px;"></div>站点介绍</div>
        <div style="width: 100%;height: 120px;color: #0ff;font-size: 16px;overflow: scroll;color: #0ff;text-indent:2rem;" :class="operationData.branchImport?'':'none'">{{operationData.branchImport ? operationData.branchImport : '暂无数据'}}</div>
      </div>
    </div>
    <div v-else class="inner-img-none" style="color:#fff">暂无数据</div>
  </div>
</template>

<script>
  export default {
    name: 'operationFiles',
    data(){
    },
    props:{
      operationData: {
        default: {},
        type: Object
      },
    },
  }

</script>


<style lang="scss" scoped>
  .container {
    width: 100%;

    .none {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .site-info {
      margin: 10px;
      .site-info-border {
        height: 170px;
        width: 23%;
        border-radius: 10px;
        border: 2px solid #0c3784;
        text-align: center;
        box-shadow: 0 0 10px #0c3784;
        animation: name .9s linear;
        margin: 10px;
        .site-info-content {
          width: 100%;
          height: 120px;
          color: #0ff;
          font-size: 1.4rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'UnidreamLED';
          span {
            color: #0ff;
            margin-right: 5px;
          }
        }
      }
    }
    ::-webkit-scrollbar {
      display: none;
      /* Chrome Safari */
    }
    .inner-img-none {
      font-size: 50px;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 25%;
      color: #000;
    }
  }
</style>